import React from 'react'

import { OpenFeatureProvider } from '@openfeature/react-sdk'
import PropTypes from 'prop-types'

export const OpenFeatureWrapper = ({ children }) => (
  <OpenFeatureProvider>{children}</OpenFeatureProvider>
)

OpenFeatureWrapper.propTypes = {
  children: PropTypes.node.isRequired,
}
